import { Component, OnInit, OnDestroy } from '@angular/core';
import { finalize, first, takeUntil } from 'rxjs/operators';
import { AppSettings } from '@app/app.settings';
import { ServicePreferences } from '@services';
import { Subject } from 'rxjs';

@Component({
    selector: 'preferences-all-notifications',
    templateUrl: './preferences-all-notifications.component.html',
    styleUrls: ['./preferences-all-notifications.component.scss']
})
export class PreferencesAllNotificationsComponent implements OnInit, OnDestroy {

    public saving = false;
    public currentUserValue: boolean;

    private _destroyed$ = new Subject();

    constructor(
        private appSettings: AppSettings,
        private servicePreferences: ServicePreferences
    ) {
    }

    ngOnInit() {
        this.currentUserValue = this.servicePreferences.getPreference('allNotifications');
    }

    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
        this._destroyed$.unsubscribe();
    }

    toggleValue($event) {
        this.currentUserValue = $event.checked;
        this.appSettings.settings.allNotifications = $event.checked;

        this.saving = true;
        this.servicePreferences.savePreference({'allNotifications': $event.checked}).pipe(
            finalize(() => {
                this.saving = false;
            }),
            first(),
            takeUntil(this._destroyed$)
        ).subscribe();
    }
}
